<template>
    <div class="qrimage">
        <van-image :src="src" v-if="src" />
    </div>
</template>
<script>
import Qrcode from 'qrcode'
export default {
    props: {
        content: {
            type: String,
            default: ''
        },
        imageSize: {
            type: Number,
            default: 500
        },
        options: {
            type: Object,
            default: () => ({})
        },
        src: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            images: {
                loading: false,
                src: ''
            }
        }
    },
    computed: {
        optionsComputed() {
            return {
                errorCorrectionLevel: 'H',
                type: 'image/jpeg',
                quality: 0.3,
                margin: 1,
                color: {
                    light: "#fff"
                },
                width: this.imageSize,
                ...this.options
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            if (!this.content) return false
            this.images.loading = true
            try {
                const url = await this.onCreate()
                this.$emit('update:src', url)
            } catch (error) {
                console.error(error)
                this.$emit('update:src', '')
                this.$emit('error', error)
            }
            this.images.loading = false
        },
        async onCreate() {
            return new Promise((resolve, reject) => {
                Qrcode.toDataURL(this.content, this.optionsComputed, async (err, base64Url) => {
                    if (err) {
                        reject(err)
                    } else {
                        resolve(base64Url)
                    }
                })
            })
        }
    },
    watch: {
        content: 'init'
    }
}
</script>
<style lang="scss" scoped>
.qrimage {
    width: 100%;
    height: 100%;

    .van-image {
        width: 100%;
        height: 100%;
    }
}
</style>